
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.771 11.104a1.225 1.225 0 00-1.432.332 1.21 1.21 0 00-.074 1.461A16.177 16.177 0 0130 29.419a10.522 10.522 0 01-3.706-4.636 1.22 1.22 0 00-1.696-.709c-5.298 2.31-8.685 7.55-8.595 13.3C16.154 46.047 23.272 53 32 53c8.729 0 15.847-6.952 16-15.627-.137-11.334-6.85-21.57-17.229-26.27z","stroke":"#5FB8EE","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    